var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5008 21C6.8081 20.9948 3.00515 17.1923 3 12.5V12.33C3.09345 7.65886 6.93979 3.93878 11.6119 4.00076C16.2841 4.06275 20.0303 7.88356 19.9998 12.5555C19.9693 17.2275 16.1734 20.9991 11.5008 21ZM7.59896 12.1515L6.40034 13.35L9.80068 16.75L16.6014 9.95001L15.4027 8.74301L9.80068 14.3445L7.59896 12.1515Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle_check.08d2e257a6e7d025154000746f73500a.svg";
export { ForwardRef as ReactComponent };